export default {
  'riskControl': {
    'common': {
      'search': 'Tìm kiếm',
      'reset': 'Đặt lại',
      'submit': 'Gửi',
      'cancel': 'Hủy',
      'confirm': 'Xác nhận',
      'operation': 'Thao tác',
      'status': 'Trạng thái',
      'createTime': 'Thời gian tạo',
      'updateTime': 'Thời gian cập nhật',
      'remark': 'Ghi chú',
      'amount': 'Số tiền',
      'currency': 'Tiền tệ',
      'orderNumber': 'Số đơn hàng',
      'memberAccount': 'Tài khoản thành viên',
      'fee': 'Phí',
      'type': 'Loại',
      'all': 'Tất cả',
      'pending': 'Đang chờ',
      'processing': 'Đang xử lý',
      'completed': 'Hoàn thành',
      'failed': 'Thất bại',
      'rejected': 'Từ chối',
      'approved': 'Đã duyệt',
      'locked': 'Đã khóa',
      'unlocked': 'Đã mở khóa',
      'dateRange': 'Khoảng thời gian',
      'startDate': 'Ngày bắt đầu',
      'endDate': 'Ngày kết thúc',
      'dateType': 'Loại ngày',
      'dateType.createTime': 'Thời gian tạo',
      'dateType.updateTime': 'Thời gian cập nhật',
      'dateType.completeTime': 'Thời gian hoàn thành',
      'dateType.applyTime': 'Thời gian nộp',
      'dateType.successTime': 'Thời gian thành công',
      'noData': 'Không có dữ liệu',
      'total': 'Tổng cộng {total} mục',
    },
    'withdrawal': {
      'title': 'Kiểm soát rủi ro rút tiền',
      'search': {
        'orderNo': 'Số đơn hàng',
        'memberAccount': 'Tài khoản thành viên',
        'currency': 'Tiền tệ',
        'orderStatus': 'Trạng thái đơn hàng',
        'withdrawType': 'Loại rút tiền',
        'dateType': 'Loại ngày',
        'startTime': 'Thời gian bắt đầu',
        'endTime': 'Thời gian kết thúc',
        'search': 'Tìm kiếm',
        'reset': 'Đặt lại'
      },
      'table': {
        'orderNo': 'Số đơn hàng',
        'memberAccount': 'Tài khoản thành viên',
        'withdrawType': 'Loại rút tiền',
        'withdrawInfo':'Thông tin tài khoản',
        'bankAccount': 'Tên tài khoản ngân hàng',
        'bankNumber': 'Số thẻ ngân hàng',
        'bankName':'Tên ngân hàng',
        'usdtAccount':'Địa chỉ USDT',
        'usdtType':'Loại chuỗi USDT',
        'usdtRate':'Tỷ giá hối đoái USDT',
        'walletRealName':'tên ví thật',
        'walletAccount':'Tài khoản ví',
        'currency': 'Tiền tệ',
        'amount': 'Số tiền',
        'fee': 'Phí',
        'realAmount': 'Số tiền thực tế',
        'orderStatus': 'Trạng thái đơn hàng',
        'riskReason': 'Lý do kiểm soát rủi ro',
        'applyTime': 'Thời gian nộp',
        'operation': 'Thao tác'
      },
      'riskReason': {
        'vipLevelMatch': 'Quy tắc phong tỏa VIP - bị phong tỏa',
        'gameArbitrageNoDeposit': 'Phong tỏa arbitrage game - Quy tắc user không nạp - bị phong tỏa',
        'gameArbitrageFirstDeposit': 'Phong tỏa arbitrage game - Quy tắc user nạp lần đầu - bị phong tỏa',
        'gameArbitrageDeviceIp': 'Phong tỏa arbitrage game - Quy tắc thiết bị/IP - bị phong tỏa',
      },
      'status': {
        'pending': 'Đang chờ',
        'processing': 'Đang xử lý',
        'success': 'Đã duyệt',
        'rejected': 'Đã từ chối',
        'paying': 'Trả tiền',
        'locked': 'Việc rút tiền đã bị khóa',
        'riskLocked': 'Đã khóa đang xem xét',
      },
      'message': {
        'fetchFailed': 'Không thể tải dữ liệu',
        'updateSuccess': 'Cập nhật thành công',
        'updateFailed': 'Cập nhật thất bại'
      },
      'button': {
        'approve': 'Duyệt',
        'reject': 'Từ chối',
        'lock': 'Khóa',
        'unlock': 'Mở khóa',
        'adminUnlock': 'Mở khóa quản trị viên'
      },
      'confirm': {
        'title':'Xác nhận hoạt động',
        'approve': 'Bạn có chắc chắn muốn duyệt yêu cầu rút tiền này?',
        'reject': 'Bạn có chắc chắn muốn từ chối yêu cầu rút tiền này?',
        'lock': 'Bạn có chắc chắn muốn khóa yêu cầu rút tiền này?',
        'unlock': 'Bạn có chắc chắn muốn mở khóa yêu cầu rút tiền này?'
      },
      'reject': {
        'reason': 'Lý do từ chối',
        'reasonRequired': 'Vui lòng nhập lý do từ chối',
        'reasonPlaceholder': 'Vui lòng nhập lý do từ chối'
      },
      'lock': {
        'reason': 'Lý do khóa',
        'reasonRequired': 'Vui lòng nhập lý do khóa',
        'reasonPlaceholder': 'Vui lòng nhập lý do khóa'
      },
      'unlock': {
        'reason': 'Lý do mở khóa',
        'reasonRequired': 'Vui lòng nhập lý do mở khóa',
        'reasonPlaceholder': 'Vui lòng nhập lý do mở khóa'
      },
      'detail': {
        'title': 'Chi tiết rút tiền',
        'basicInfo': 'Thông tin cơ bản',
        'riskInfo': 'Thông tin rủi ro',
        'operationLog': 'Nhật ký thao tác',
        'memberInfo': 'Thông tin thành viên',
        'accountInfo': 'Thông tin tài khoản',
        'withdrawInfo': 'Thông tin rút tiền',
        'riskLevel': 'Cấp độ rủi ro',
        'riskScore': 'Điểm rủi ro',
        'riskTags': 'Nhãn rủi ro',
        'operationTime': 'Thời gian thao tác',
        'operator': 'Người thao tác',
        'operation': 'Thao tác',
        'remark': 'Ghi chú'
      }
    },
    'blacklistQuery': {
      'title': 'Truy vấn danh sách đen',
      'name': 'Tên',
      'nameRequired': 'Vui lòng nhập tên',
      'namePlaceholder': 'Vui lòng nhập tên (hỗ trợ tìm kiếm một phần)',
      'firstName': 'Tên',
      'middleName': 'Tên đệm',
      'lastName': 'Họ',
      'birthdate': 'Ngày sinh',
      'source': 'Nguồn',
      'photo': 'Ảnh',
      'resultTitle': 'Kết quả truy vấn',
      'queryFailedWithCode': 'Truy vấn thất bại, mã trạng thái: {code}',
      'queryFailed': 'Truy vấn thất bại',
      'unavailable': 'Không có sẵn',
      'banned': 'Đã cấm',
      'photoAlt': 'Ảnh'
    },
    'riskReason':{
      'suspected': 'Kiểm soát rủi ro nghi ngờ',
      'manualReview': 'Chế độ xem xét thủ công',
      'depositWithdrawDiffExceed': 'Chênh lệch tiền gửi-rút tiền vượt quá giới hạn',
      'depositWithdrawPercentExceed': 'Tỷ lệ tiền gửi và rút tiền vượt quá giới hạn',
      'totalWinLossExceed': 'Tổng số tiền thắng và thua vượt quá giới hạn',
      'withdrawAmountExceed': 'Số tiền rút vượt quá giới hạn',
      'totalBonusExceed': 'Tổng số tiền thưởng vượt quá giới hạn',
      'bonusDepositRatioExceed': 'Tỷ lệ tiền thưởng gửi vượt quá giới hạn',
      'depositWithdrawBothExceed': 'Chênh lệch tiền gửi-rút tiền và tỷ lệ phần trăm đều vượt quá giới hạn',
      'bonusBothExceed': 'Tổng tiền thưởng và tỷ lệ tiền gửi tiền thưởng vượt quá giới hạn',
      'noDeposit':'Số tiền gửi bằng 0, muốn ăn chực',
      'vipLevelMatch': 'Quy tắc phong tỏa VIP - bị phong tỏa',
      'gameArbitrageNoDeposit': 'Phong tỏa arbitrage game - Quy tắc user không nạp - bị phong tỏa',
      'gameArbitrageFirstDeposit': 'Phong tỏa arbitrage game - Quy tắc user nạp lần đầu - bị phong tỏa',
      'gameArbitrageDeviceIp': 'Phong tỏa arbitrage game - Quy tắc thiết bị/IP - bị phong tỏa',
    }
  }
}
